__turbopack_context__.v({
  "image": "styles-module-scss-module__V61Lwa__image",
});
